import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { closeMenu } from '../redux/appSlice'
import CommentSection from './CommentSection'
import LiveChat from './LiveChat'

const VideoWatch = () => {
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(closeMenu())
  }, [])
  return (
    <div className="flex flex-col w-full">
      <div className="px-5 flex w-full">

        <div className="">
          <iframe
            width="1200"
            height="600"
            src={"https://www.youtube.com/embed/" + searchParams.get("v")}
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          ></iframe>
        </div>
        <div>
          <LiveChat />
        </div>

      </div>

      <CommentSection />
    </div>
  )
}

export default VideoWatch
